import React from "react";
import set from "@rill/set";
import { useTranslation } from "react-i18next";
import SupportNav from "../../../parts/support-nav";

function View(props) {
  const { t } = useTranslation("dashboard");
  return (
    <div className="Main Support-Downloads">
      <SupportNav />

      <div className="Content">
        <div className="Downloads">
          <div className="item">
            <div className="type" data-type="pdf">
              PDF
            </div>
            <div className="title">{t("supportDownloads.download1Title")}</div>
            <a
              href="/img/support/3-Types-of-Exercise-Categories.pdf"
              target="_blank"
            ></a>
          </div>

          <div className="item">
            <div className="type" data-type="pdf">
              PDF
            </div>
            <div className="title">{t("supportDownloads.download2Title")}</div>
            <a
              href="/img/support/Defining-Metrics-Based-Training.pdf"
              target="_blank"
            ></a>
          </div>

          <div className="item">
            <div className="type" data-type="pdf">
              PDF
            </div>
            <div className="title">{t("supportDownloads.download3Title")}</div>
            <a
              href="/img/support/The-9-Metrics-of-MyStrengthBook.pdf"
              target="_blank"
            ></a>
          </div>

          <div className="item">
            <div className="type" data-type="pdf">
              PDF
            </div>
            <div className="title">{t("supportDownloads.download4Title")}</div>
            <a
              href="/img/support/The-Benefits-of-Metrics-Based-Training.pdf"
              target="_blank"
            ></a>
          </div>
        </div>
      </div>
    </div>
  );
}

const Downloads = (app) => {
  app.get(
    "/downloads",
    set("heading", "Downloads"),
    ({ res }) => (res.body = <View />)
  );
};

export default Downloads;
